import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { designationServices } from "../../../../APIServices/UserData/designationServices";

const AddDesignation = ({ show, hide, title, getDesignationList }) => {
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewDesignation = async () => {
    setLoader(true)
    let userData = {}
    userData.name = name
    let data = await designationServices.addNewDesignation(userData)
    if (data?.statusCode === 200) {
      getDesignationList()
      clearData();
    }
    setLoader(false)
  }
  
  const clearData = () => {
    setName("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (!show) {
      setName("");
      setLoader(false)
    }
  }, [show]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={clearData} style={{ fontSize: 12 }} variant="light" >
              Cancel
            </Button>
            <Button
              disabled={!name || loader}
              onClick={addNewDesignation}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddDesignation;
